import { render, staticRenderFns } from "./ArrowForward.vue?vue&type=template&id=10ff2858&scoped=true&"
import script from "./ArrowForward.vue?vue&type=script&lang=js&"
export * from "./ArrowForward.vue?vue&type=script&lang=js&"
import style0 from "./ArrowForward.vue?vue&type=style&index=0&id=10ff2858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff2858",
  null
  
)

export default component.exports